/**
 * @ngdoc controllers
 * @memberof mercury.modules.stock
 * @name StockSupplierListCtrl
 */
angular.module('mercury.modules.stock.supplier')
.controller('StockSupplierListCtrl', ["$uibModal", "$scope", "StockSuppliers", "title", function($uibModal, $scope, StockSuppliers, title) {
  $scope.nameFilter = {name: ''};
  title.set('Manage Suppliers');

  $scope.showDeleted = false;
  $scope.deletedFilter = function(obj) {
    return (obj.removedAt !== null) == $scope.showDeleted;
  };

  var modalInstance;

  /**
  * Initially load all suppliers, including the deleted ones.
  * This page uses the "Show Deleted Suppliers" checkbox
  * control if deleted suppliers are shown
  */
  $scope.allSuppliers = StockSuppliers.getAll(true);

  /**
  * Set the datestamp removed to today for supplier and save it to the server.
  */
  $scope.deleteSupplier = function(supplier) {
    StockSuppliers.remove(supplier)
    .then(function() {
      supplier.removedAt = moment().format();
    });
  };

  $scope.updateCustomerNumber = function(supplier) {
    StockSuppliers.patch(supplier.id, 'customerNumber', supplier.customerNumber);
  };

  /**
  * Set the datestamp removed to null for the supplier and save it to the server.
  */
  $scope.restoreSupplier = function(supplier) {
    StockSuppliers.restore(supplier)
    .then(function() {
      supplier.removedAt = null;
    });
  };

  $scope.editSupplier = function(supplier) {
    var modalInstance = $uibModal.open({
      templateUrl: 'modules/stock/supplier/edit.tpl.html',
      controller: 'StockSupplierEditCtrl',
      size: 'lg',
      resolve: {
        supplierId: function() {
          return supplier.id;
        }
      }
    });

    modalInstance.result.then(function(updatedSupplier) {
      angular.forEach($scope.allSuppliers, function(existingSupplier, existingIndex) {
        if (updatedSupplier.id == existingSupplier.id) {
          $scope.allSuppliers.splice(existingIndex, 1, updatedSupplier);
        }
      });
    });
  };

  $scope.addSupplier = function() {
    var modalInstance = $uibModal.open({
      templateUrl: 'modules/stock/supplier/add.tpl.html',
      controller: 'StockSupplierAddCtrl',
      size: 'lg',
      resolve: {
        existingMasterSuppliers: function() {
          var existingMasterIds = [];
          angular.forEach($scope.allSuppliers, function(supplier) {
            if (supplier.masterId && !supplier.removedAt) {
              existingMasterIds.push(supplier.masterId);
            }
          });
          return existingMasterIds;
        }
      }
    });

    modalInstance.result.then(function(newSupplier) {
      $scope.allSuppliers.push(newSupplier);
    });
  };

  $scope.mergeSupplierComplete = function(form, sourceId, destId) {
    form.$setSubmitted();

    //Form validation for if the source and dest suppliers are the same.
    form.source.$setValidity('same', !sourceId || sourceId != destId);
    form.destination.$setValidity('same', !destId || sourceId != destId);

    if (form.$invalid) {
      return;
    }

    $scope.mergeProcessing = StockSuppliers.merge(sourceId, destId);
    $scope.mergeProcessing.then(function(result) {
      angular.forEach($scope.allSuppliers, function(supplier, index) {
        if (supplier.id == result.source.id) {
          $scope.allSuppliers.splice(index, 1, result.source);
        } else if (supplier.id == result.dest.id) {
          $scope.allSuppliers.splice(index, 1, result.dest);
        }
      });
      modalInstance.close();
    });
  };

  $scope.mergeSupplier = function() {
    modalInstance = $uibModal.open({
      templateUrl: 'modules/stock/supplier/merge.tpl.html',
      scope: $scope
    });
  };
}]);
